import React from "react";
import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";
import SectionHeader from "../SectionHeader";
import { teamMembers } from "../../data/mockData";

const Team = () => (
  <>
    <SectionHeader
      eyebrow="Leadership"
      title="Leadership"
      description="Leadership and representative roles associated with Refwa."
      align="center"
    />
    <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
      {teamMembers.map((member) => (
        <Grid item xs={12} md={6} lg={4} key={member.id}>
          <Card
            sx={{
              height: "100%",
              border: "1px solid var(--color-border)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
              transition: "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "var(--shadow-soft)",
                borderColor: "rgba(183, 132, 69, 0.22)",
              },
            }}
          >
            <CardContent sx={{ p: { xs: 3, md: 3.5 }, textAlign: "center" }}>
              <Avatar
                src={member.image}
                alt={member.name}
                sx={{
                  width: 100,
                  height: 100,
                  mx: "auto",
                  mb: 2.25,
                  p: 0.25,
                  border: "3px solid rgba(183, 132, 69, 0.2)",
                  boxShadow: "0 12px 24px rgba(10, 18, 30, 0.08)",
                }}
              />
              <Typography variant="h5">{member.name}</Typography>
              <Typography variant="subtitle2" sx={{ color: "primary.main", mt: 0.8, mb: 1.5 }}>
                {member.role}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {member.bio.replace("â€™", "'")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </>
);

export default Team;
